<div class="blockUI blockOverlay">
</div>
<div class="blockUI blockMsg blockElement">
  <div class="d-flex justify-content-center">
    <p class="mb-0">
      {{'Wait' | translate}}
    </p>
    <div class="sk-wave m-0 ms-2">
      <div class="sk-rect sk-wave-rect"></div>
      <div class="sk-rect sk-wave-rect"></div>
      <div class="sk-rect sk-wave-rect"></div>
      <div class="sk-rect sk-wave-rect"></div>
      <div class="sk-rect sk-wave-rect"></div>
    </div>
  </div>
</div>